import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'

import useTextContents from '../../../hooks/useTextContents'
import { CurrentFormUrlPathContext } from '../../AppRoot/hooks/useAppRootLogic'
import { WorkflowTypes } from '../../../common/workflow'
import { AppLinks } from '../../../environment/app-links'
import { invokeLoadingWithText } from '../../../common/invokeLoading'
import { createAndStartHub } from '../../../store/middleware/credential.action'
import { AppDispatch, apphistory, AppState } from '../../../store'
import useAppInitLogic from '../../../hooks/useAppInitLogic'
import { SET_APP_HAS_ERROR } from '../../../store/actions/application-actions'
import { APP_INIT_TYPES } from '../../../hooks/HooksProps'
import { APP_SOURCE_TYPES } from '../../../store/types'
import analyticsService from '../../../service/analytics.service'


/**
 * Custom hook obsługujący logikę strony startowej aplikacji
*/
const useStartPageLogic = () => {
   const dispatch = useDispatch<AppDispatch>()
   const  textContent = useTextContents()
   const { setCurrentUrlFormPath } = useContext(CurrentFormUrlPathContext)
   const { getAccessToken, getAppConfiguration, handleAnalyticsRequests } = useAppInitLogic(APP_INIT_TYPES.START_PAGE)
   const ANALYTICS_EVENT_TYPES_NAMES = useSelector((state: AppState) => state.lenConfigState.analyticsEventTypesNames)



   useEffect(()=>{
      (async () => {// Inicjalizacja tekstów na stronę oraz pobieranie konfiguracji projektu. Zapis danych do state'a
         try {
            const workflowId = await getAccessToken()

            switch (workflowId) {
               // ============================== STARTING FORM (INTEGRATOR) ==============================
                  case WorkflowTypes.LEN_NORMAL: {
                     await getAppConfiguration()
                     await handleAnalyticsRequests()

                     // ================ POŁĄCZENIE Z HUBEM ================
                        createAndStartHub(dispatch, APP_SOURCE_TYPES.FROM_EXTERNAL_INTEGRATOR)
                     // ====================================================

                     break;
                  }
               // =============================================================================

               // ============================== FORMULARZ OPENA ==============================
                  case WorkflowTypes.LEN_PAYTREE_NORMAL: {
                     await handleAnalyticsRequests()

                     // ================ POŁĄCZENIE Z HUBEM ================
                     createAndStartHub(dispatch, APP_SOURCE_TYPES.STARTING_FORM)
                     // ====================================================

                     setCurrentUrlFormPath(AppLinks.extendedInfoForm)
                     dispatch(invokeLoadingWithText(textContent('loaders.default'), AppLinks.extendedInfoForm))
                     break;

                  }
               // =============================================================================

               default: {
                  console.error(`Nieobsługiwany workflowId: ${workflowId}`)
                  throw new Error(`Nieobsługiwany workflowId: ${workflowId}`)
               } 
            }
         }
         catch (e: any) {
            const ERROR_ANALYTICS_DATA = {
               id: analyticsService.DISPLAY_ERROR_PAGE_IDS.START_PAGE_ERROR,
               reason: "Błąd podczas pobierania tokena lub konfiguracji aplikacji, przy wejściu klienta w proces za pomocą linku startowego (/start?).",
               details: {
                  description: e.message,
                  errorDataFromBackend: e?.data,
               },
            }

            dispatch({ type: SET_APP_HAS_ERROR }) //Ustawiamy globalny błąd aplikacji co spowoduje przejście na ekran z błędem
            await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.FrontendErrorPageDisplayed, JSON.stringify(ERROR_ANALYTICS_DATA, undefined, 3))
         
            return
         }
      })()

   // eslint-disable-next-line react-hooks/exhaustive-deps
   },[])
}

export default useStartPageLogic
